import { render, staticRenderFns } from "./ApproveRejectComponent.vue?vue&type=template&id=b685f640&scoped=true"
import script from "./ApproveRejectComponent.vue?vue&type=script&lang=js"
export * from "./ApproveRejectComponent.vue?vue&type=script&lang=js"
import style0 from "./ApproveRejectComponent.vue?vue&type=style&index=0&id=b685f640&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b685f640",
  null
  
)

export default component.exports